import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectChatLoading, selectSaveProfileNameV2, selectSaveUrlV2 } from '../Selector/ChatBotV2Selector';
import { actions } from '../Slice/ChatbotV2Slice';
var StatesAndActions = function (props) {
    var getStatesAndActions = props.getStatesAndActions;
    var dispatch = useDispatch();
    var saveProfileName = useSelector(selectSaveProfileNameV2);
    var saveUrl = useSelector(selectSaveUrlV2);
    var chatLoading = useSelector(selectChatLoading);
    useEffect(function () {
        getStatesAndActions({
            chatStates: {
                saveProfileName: saveProfileName,
                saveUrl: saveUrl,
                chatLoading: chatLoading,
            },
            chatActions: {
                setCertificationPrompt: function (data) { return dispatch(actions.setCertificationPrompt(data)); },
                sendFeedback: function (data) { return dispatch(actions.sendFeedback(data)); },
                resetChatbotPopup: function () { return dispatch(actions.resetChatbotPopup()); },
                setSaveUrl: function (data) { return dispatch(actions.setSaveUrl(data)); },
                setSaveProfileName: function (data) { return dispatch(actions.setSaveProfileName(data)); },
                setShowLibrary: function (data) { return dispatch(actions.setShowLibrary(data)); },
                setShowExamplePrompts: function (data) { return dispatch(actions.setShowExamplePrompts(data)); },
                resetChatHistory: function () { return dispatch(actions.resetChatHistory()); },
                setSelectedConversationId: function (data) { return dispatch(actions.setSelectedConversationId(data)); },
                setHistoryPanelOpened: function (data) { return dispatch(actions.setHistoryPanelOpened(data)); },
            }
        });
    }, [saveProfileName, saveUrl, chatLoading]);
    return (_jsx(_Fragment, {}));
};
export default StatesAndActions;
